import { MagicFrameEngine } from '@ff-image-frame-engine/magicFrameEngine';

let engineInstance: any = null;

export const getMagicFrameEngine = (): any => {

    if (!engineInstance) {
        engineInstance = new MagicFrameEngine();
    }

    return engineInstance;
};